import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import routes from 'src/configs/routesConfig';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import './app/instrument';
import * as Sentry from '@sentry/react';

/**
 * The root element of the application.
 */
const container = document.getElementById('app');

if (!container) {
	throw new Error('Failed to find the root element');
}

const root = createRoot(container, {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn('Uncaught error', error, errorInfo.componentStack);
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler(),
});

const router = createBrowserRouter(routes);

root.render(
	<CookiesProvider>
		<RouterProvider router={router} />
	</CookiesProvider>
);